module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_3.c8aa8e1a.png";